// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-input .custom-dropdown {\n  border: none; }\n  .dropdown-input .custom-dropdown .dropdown-menu.show {\n    top: 12px !important;\n    left: 35px !important; }\n\n.dropdown-input .input-group {\n  min-height: 51px; }\n", ""]);
// Exports
module.exports = exports;
